import { cn } from '@massilia/ui'

import { FlightSearchForm } from '@/components/research-bar/-form-groups/flight-search-form'

interface ResearchBarFormShellProps {
  className?: string
  errorPopoverSide?: 'bottom' | 'top'
  errorsDisplayType?: 'bellow' | 'popover'
}

export function ResearchBarFormShell({
  className,
  errorPopoverSide = 'bottom',
  errorsDisplayType = 'popover',
}: ResearchBarFormShellProps) {
  return (
    <div
      className={cn(
        'flex scale-95 flex-col items-start gap-8 rounded-lg bg-white p-4 shadow-xl md:scale-100 md:p-6',
        'overflow-visible',
        className
      )}
    >
      <FlightSearchForm errorPopoverSide={errorPopoverSide} errorsDisplayType={errorsDisplayType} />
    </div>
  )
}
